module.exports = __webpack_public_path__ + "img/ic_note_add.2460cc67.svg";